<template>
  <div class="main-footer mt-30 | d-flex justify-content-between">
    <nav>
      <ul class="footer-nav">
        <li>
          <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/Datenschutz/Datenschutzinformationen_McDonalds_Junior_Club.pdf">Datenschutz</a>
        </li>
        <li>
          <a href="https://www.mcdonalds.de/impressum">Impressum</a>
        </li>
        <li class="d-flex d-sm-block justify-content-center justify-content-sm-end-center">
          <!-- OneTrust Cookies Settings button start -->
<!--          <a class="optanon-show-settings">Cookie Einstellungen</a>-->
          <!-- OneTrust Cookies Settings button end -->
        </li>
      </ul>
    </nav>
    <div class="logo">
      <a class="logo-footer" href="http://mcdonalds.de">McDonald's</a>
      <span class="mcd-copyright">&copy; {{copyrightYear}} McDonald’s. Alle Rechte vorbehalten.</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "footerComponent",
        computed: {
            copyrightYear() {
              const today = new Date();
              return today.getFullYear();
            }
        }
    };
</script>
